"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.indi = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _utilities = require("./utilities");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }
function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }
function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }
/* Intercept all request to ensure headers are correct */
/* Wraps axios with additional app-specific features/data points */
var _config = /*#__PURE__*/new WeakMap();
var _cacheKeys = /*#__PURE__*/new WeakMap();
var _apiUrl = /*#__PURE__*/new WeakMap();
var _endpoints = /*#__PURE__*/new WeakMap();
class indi {
  constructor() {
    _classPrivateFieldInitSpec(this, _config, {
      writable: true,
      value: require("./indi.config.json")
    });
    _classPrivateFieldInitSpec(this, _cacheKeys, {
      writable: true,
      value: {
        profile: "rePR" //TODO: [INDI-90] Replace this with a prod-profile.  Or have a configuration attribute that can be set.
      }
    });
    _classPrivateFieldInitSpec(this, _apiUrl, {
      writable: true,
      value: "https://indigenux.app"
    });
    _classPrivateFieldInitSpec(this, _endpoints, {
      writable: true,
      value: {
        profile: "/p/_meta",
        refreshToken: "/refreshtoken/"
      }
    });
    _defineProperty(this, "profile", {
      /* MUST HAVE THESE PROPERTIES */
      logLevel: 0,
      //ALL FOR NOW.
      /* Contains the following properties:
          navigation: [{
              title: "Menu item 1",
              id: "menu-item-1",
              items: [{
                  title: "Submenu item 1",
                  href: "/local/route"
              }],
          }],
          routes: [{
              path: '/',
              view: 'HomeView', 
              element: () => {
                  //See: https://www.digitalocean.com/community/conceptual_articles/react-loading-components-dynamically-hooks
              }
          }],
          languages: [{
              value: 'en',
              text: 'English',
              showFlag: true
          }],
          page: {
              title: 'Home - Indigenux.com', 
              layout: 'Main',
              requireLogin: false,
              labels: [{
                  'key': 'value',
              }],
              errorMessages: [
                  'key': 'value',
              ]
          },
          logLevel: 'OFF|ERROR|WARN|INFO|DEBUG|ALL', 
          defaultLanguage: 'en',
          snackLimit: 3,
          title: "Page title",
          cachingStrategy: "CACHE_ALL", 
          version: '1.0',
      
      */
      routes: [],
      navigation: [{
        title: "Menu item 1",
        id: "menu-item-1",
        items: [{
          title: "Submenu item 1",
          href: "/local/route"
        }]
      }]
    });
    _defineProperty(this, "loaded", false);
  }
  getProfile(forceReload) {
    _utilities.logger.debug("Getting Site's profile.");
    let cachedData = _utilities.cacheUtil.getItem(_classPrivateFieldGet(this, _cacheKeys).profile);
    if (!cachedData) {
      /* A cached version was found.  See if it was loaded fully. */
      if (forceReload || !cachedData.loaded) {
        cachedData = null; //Clear variable so next statement can renew information.
      }
    }
    if (cachedData === null) {
      const apiCall = _classPrivateFieldGet(this, _endpoints).profile + (_classPrivateFieldGet(this, _cacheKeys).profile !== "" ? "?profile=" + _classPrivateFieldGet(this, _cacheKeys).profile : "");
      return this.get(apiCall).then(response => {
        this.loaded = true;
        this.profile = response.data.content;
        _utilities.cacheUtil.setItem(_classPrivateFieldGet(this, _cacheKeys).profile, this.profile);
        return this.handleSuccess(this.profile);
      }).catch(error => {
        return this.handleError(error);
      });
    }
    this.profile = cachedData;
    return this.handleSuccess(cachedData);
  }
  getLogLevelValue() {
    const logLevel = this.profile.logLevel;
    return _utilities.logger.value(logLevel);
  }
}
exports.indi = indi;
;